export const generateTyresTitleRadioButton = (width: string, height: string, diameter: string): string => {
  if (height === '0') {
    return `${width} R${diameter}`;
  }

  return `${width}/${height} R${diameter}`;
};
